<template>
  <b-col
    cols="12"
    class="mb-4 d-lg-flex justify-content-lg-end"
    sm="12"
    md="4"
    lg="3"
    xl="3">
    <b-btn
      class="d-flex align-items-center justify-content-center boton-agregar"
      style="color: white"
      variant="info"
      @click="mostrarModalAgregar"
      text
      color="blue">
      <feather :type="iconBoton" class="feather-sm mr-2"></feather>
      {{ textoBoton }}
    </b-btn>
  </b-col>
</template>

<script>
export default {
  props: {
    textoBoton : {
        type: String,
        required: true,
    },
    iconBoton: {
        type: String,
        required: true,
    },
  },
  methods: {
    mostrarModalAgregar() {
      this.$emit("mostrarModalAgregar");
    },
  },
};
</script>

<style>
  @media (max-width: 960px) {
    .boton-agregar{
      width: 100%;
      margin-bottom: -0.8rem;
    }
  }
</style>
